import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

interface AlertModalProps {
    isOpen: boolean;
    message: string;
    onClose: () => void;
    type?: 'alert' | 'confirm';
    onConfirm?: () => void;
}

export default function AlertModal({ isOpen, message, onClose, type = 'alert', onConfirm }: AlertModalProps) {
    const { t } = useTranslation()

    // ESC 키로 닫기
    useEffect(() => {
        if (!isOpen) return;

        const handleEsc = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', handleEsc);
        return () => window.removeEventListener('keydown', handleEsc);
    }, [isOpen, onClose]);

    // Early return must come AFTER all hooks
    if (!isOpen) return null;

    // Auto-detect if message is a translation key
    const isTranslationKey = /^[a-z]+\.[a-z.]+$/i.test(message)
    const displayMessage = isTranslationKey ? t(message) : message


    return (
        <div className="modal modal-open z-[9999]">
            <div className="modal-box relative">
                <button
                    onClick={onClose}
                    className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
                >
                    ✕
                </button>
                <h3 className="font-bold text-lg mb-4">
                    {type === 'confirm' ? t('common.confirm') : t('common.alert')}
                </h3>
                <p className="py-4 whitespace-pre-wrap">{displayMessage}</p>
                <div className="modal-action">
                    {type === 'confirm' && (
                        <button onClick={onClose} className="btn">
                            {t('common.cancel')}
                        </button>
                    )}
                    <button onClick={type === 'confirm' ? onConfirm : onClose} className="btn btn-primary">
                        {t('common.confirm')}
                    </button>
                </div>
            </div>
            <div className="modal-backdrop" onClick={onClose}></div>
        </div>
    );
}
